const option = state => state.option

export default {
  option
}
